import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { MatProgressBar } from '@angular/material/progress-bar';
import { FADE_IN_OUT_ANIMATION } from '@partners/ui';
import { SimpleFieldDirective } from '../../directives';

@Component({
  standalone: true,
  selector: 'field-progress-bar',
  template: `
    @if (fieldAccessor.isPending$$()) {
    <mat-progress-bar [@fadeInOut] mode="indeterminate" class="dropdown-progress-bar"       />
    }
  `,
  animations: [FADE_IN_OUT_ANIMATION],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MatProgressBar],
  host: {
    class: 'field-progress-bar'
  }
})
export class FieldProgressBarComponent<T> {
  @Input()
  fieldAccessor: SimpleFieldDirective<T>;
}
